import * as React from 'react';
import { VisuallyHiddenStyled } from './visually-hidden.component.style';
/**
 * Componente visualmente escondido mas cujo conteúdo será lido pelo leitor de telas
 * https://webaim.org/techniques/css/invisiblecontent/#techniques
 */
export var VisuallyHidden = function (props) {
    return React.createElement(VisuallyHiddenStyled, null, props.children);
};
